import { Routes } from '@angular/router';
import { AuthGuard } from './guards/auth.guard';

import { AdminLayoutComponent } from './layouts/admin/admin-layout.component';
import { AuthLayoutComponent } from './layouts/auth/auth-layout.component';
import { UnauthorizedComponent} from './pages/unauthorized/unauthorized.component'

const BIBLIOTECA_ROLES: string[] = [
    'SFG_ADM_SYS','ENCARGADO_OPERACIONES_FOGAPY','ANALISTA_FONDO','ASISTENTE_OP_FONDO','SFG_ADM_SEG',
    'DIRECTOR_OA','ANALISTAINFORMATICO','COMERCIAL_FONDO','ANALISTA_LEGAL','CONTABLE_FONDO',
    'SFG_INF_ADM','SFG_ADM_TI','SFG_CONFIGURADOR_SISTEMA','SFG_CONFIGURADOR_USUARIO',
    'SFG_GERENTE_GENERAL','SFG_ANALISTA_CONTABILIDAD','SFG_CONTADOR_FOGAPY','ENCARGADO_COMERCIAL_FG',
    'ANALISTA_FINANCIERO_FONDO','ANALISTA_RIESGO_FONDO','GERENTE_FOGAPY','ANALISTA_OP_FONDO',
    'ANALISTA_RIESGOS_AFD','ANALISTA_LEGAL_AFD','GERENTE_RIESGOS_AFD','ASESOR_LEGAL_AFD',
    'ENC_LEGALES_AFD','ADMINISTRADOR_IFP','LICITADOR_IFP','COMERCIAL_IFP','RIESGO_IFP',
    'OPERACIONES_IFP','FACTURADOR_IFP','SEGURIDAD_IFP'
];

export const AppRoutes: Routes = [
    {
        path: '',
        redirectTo: 'dashboard/inicio',
        canActivate: [AuthGuard],
        pathMatch: 'full',
    },
    {
        path: 'biblioteca',
        component: AdminLayoutComponent,
        canActivate: [AuthGuard],
        children: [
            {
                path: '',
                loadChildren: () => import('./administracion/biblioteca/biblioteca.module').then(m => m.BibliotecaModule),
                data:{expectedRol: BIBLIOTECA_ROLES, expectedPermission:['P980']}
            }
        ]
    }, {
        path: '',
        component: AdminLayoutComponent,
        canActivate: [AuthGuard],
        children: [
            {
                path: 'dashboard',
                canActivate:[AuthGuard],
                loadChildren: () => import('./dashboard/dashboard.module').then(m => m.DashboardModule),
                data: {expectedRol:['SFG_CONT_REG', 'SFG_CONT_AUT', 'SFG_INF_ADM',
                    'ROLE_ENCARGADO_FONDO','ROLE_SFG_GERENTE_GENERAL','ROLE_SFG_ANALISTA_CONTABILIDAD','ROLE_SFG_CONTADOR_FOGAPY'],
                expectedPermission:['P965']}
            },
            {
                path: 'contabilidad',
                canActivate:[AuthGuard],
                loadChildren: () => import('./administracion/contabilidad/contabilidad.module').then(m => m.ContabilidadModule),
                data: {expectedRol:['SFG_CONT_REG', 'SFG_CONT_AUT', 'SFG_CONT_INF','SFG_INF_ADM',
                'ROLE_SFG_CONTADOR_FOGAPY', 'ROLE_SFG_ANALISTA_CONTABILIDAD','ROLE_ENCARGADO_FONDO'],
                expectedPermission:['P966' ]}

            },
            {
                path: 'reportes',
                loadChildren: () => import('./administracion/reportes/reportes.module').then(m => m.ReportesModule),
                data: {expectedRol:['ROLE_SFG_CONTADOR_FOGAPY', 'ROLE_SFG_ANALISTA_CONTABILIDAD','ROLE_ENCARGADO_FONDO',
                 'ROLE_ANALISTA_LEGAL', 'SFG_GERENTE_GENERAL','ROLE_COMERCIAL_FONDO'],
                expectedPermission:['P967']}

            },
            {
                path: 'garantia',
                canActivate:[AuthGuard],
                loadChildren: () => import('./administracion/garantia/garantia.module').then(m => m.GarantiaModule),
                data: {expectedRol:['ROLE_FOGAPY','ADMINISTRADOR_IFP', 'LICITADOR_IFP',
                'COMERCIAL_IFP',
                'RIESGO_IFP',
                'OPERACIONES_IFP',
                'FACTURADOR_IFP',
                'SEGURIDAD_IFP', 
                'ROLE_AREA_LEGAL', 'ROLE_GERENCIA_RIESGOS' , 'SFG_CONT_REG', 'SFG_CONT_AUT', 'SFG_CONT_INF','SFG_INF_ADM',
                'ROLE_SFG_CONTADOR_FOGAPY', 'ROLE_SFG_ANALISTA_CONTABILIDAD','ROLE_ENCARGADO_FONDO','ROLE_COMERCIAL_FONDO','ROLE_ANALISTA_LEGAL','ANALISTA_OP_FONDO','ENCARGADO_OPERACIONES_FOGAPY'],
                expectedPermission:['P968']}

            },
            {
                path: 'cartera',
                canActivate:[AuthGuard],
                loadChildren: () => import('./administracion/cartera/cartera.module').then(m => m.CarteraModule),
                data: {expectedRol:['ROLE_FOGAPY', 'ROLE_AREA_LEGAL', 'ROLE_GERENCIA_RIESGOS' , 'SFG_CONT_REG', 'SFG_CONT_AUT', 'SFG_CONT_INF','SFG_INF_ADM',
                'ROLE_SFG_CONTADOR_FOGAPY', 'ROLE_SFG_ANALISTA_CONTABILIDAD','ROLE_ENCARGADO_FONDO','ROLE_COMERCIAL_FONDO','ROLE_ANALISTA_LEGAL'],
                expectedPermission:['P975']}

            },
            {
                path: 'mantenimiento',
                canActivate:[AuthGuard],
                loadChildren: () => import('./administracion/mantenimiento/mantenimiento.module').then(m => m.MantenimientoModule),
                data: {expectedRol:['ROLE_SFG_ADM_TI','ROLE_SFG_CONTADOR_FOGAPY', 'ROLE_SFG_ANALISTA_CONTABILIDAD'],
                expectedPermission:['P964']}
            },
            {
                path: 'panelcontrol',
                loadChildren: () => import('./administracion/panel-control/panel-control.module').then(m => m.PanelControlModule),
                data: {expectedRol:['ROLE_SFG_ADM_TI', 'SFG_INF_ADM'],
                expectedPermission:[]}
            },
            {
                path: 'seguimientotarea',
                loadChildren: () => import('./administracion/seguimiento-tarea/seguimiento-tarea.module').then(m => m.SeguimientoTareaModule)


            },
            {
                path: 'configuracion',
                loadChildren: () => import('./administracion/configuracion/configuracion.module').then(m => m.ConfiguracionModule),
                data: {expectedRol:['SFG_CONFIGURADOR_SISTEMA', 'SFG_CONFIGURADOR_USUARIO', 'ROLE_SFG_ADM_TI'],
                expectedPermission:['P']}
            }, {
                path: 'unauthorized',
                component: UnauthorizedComponent
            }

        ]
    }, {
        path: '',
        component: AuthLayoutComponent,
        children: [{
            path: 'pages',
            loadChildren: () => import('./pages/pages.module').then(m => m.PagesModule)
        }]
    }
];
